import React from "react";
import { UnknownError } from "../pages";

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const currentUrl = window.location.href;
    //console.log("url", currentUrl);
    //console.log("ini error", error);
    //console.log("ini info", info.componentStack);
    localStorage.removeItem("user_info");
  }

  render() {
    if (this.state.hasError) {
      return <UnknownError />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
